// extracted by mini-css-extract-plugin
export var $animation_name = "Nav-module--$animation_name--06dd1";
export var Nav = "Nav-module--Nav--d2f90";
export var NavMain = "Nav-module--NavMain--bbe0a";
export var NavMain___hasActive = "Nav-module--NavMain___hasActive--b97ee";
export var NavSub = "Nav-module--NavSub--3e6bd";
export var NavSub___animate = "Nav-module--NavSub___animate--30bdd";
export var NavSub___hasActive = "Nav-module--NavSub___hasActive--f7e25";
export var NavSub___noAnimate = "Nav-module--NavSub___noAnimate--65c90";
export var Nav__desktop = "Nav-module--Nav__desktop--a98ef";
export var Nav__link = "Nav-module--Nav__link--1d4a7";
export var Nav__link___active = "Nav-module--Nav__link___active--47a25";
export var Nav__mobile = "Nav-module--Nav__mobile--e1511";
export var Nav__subTitle = "Nav-module--Nav__subTitle--392be";
export var animateIn = "Nav-module--animateIn--f5c82";